import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { config } from '@/services/config';
import { get } from 'lodash';
import { TaskTableData } from '@/types/Task';
import { createTableHeaders, createTopTableHeaders } from '@/helpers/tables';
import { createTasks } from '@/helpers/tasks';

export type Getters = {
  getTaskList(state: State): TaskTableData;
  getTaskListAll(state: State): TaskTableData;
  isTaskDataLoading(state: State): boolean;
  getNewTasksCount(state: State): number;
  getNewTasksAllCount(state: State): number;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getTaskList: state => {
    const taskList = state.taskList;
    const taskTableConfig = get(config.layout, 'tableLayouts.taskTable', {});
    const configTopHeaders = get(taskTableConfig, 'topHeaders', []);
    const configHeaders = get(taskTableConfig, 'mainHeaders', []);

    return {
      items: createTasks(taskList),
      headers: createTableHeaders(configHeaders),
      topHeaders: createTopTableHeaders(configTopHeaders),
      totalResultCount: get(state, 'totalResultCountTaskList', 0),
    };
  },
  getTaskListAll: state => {
    const taskList = state.taskListAll;
    const taskTableConfig = get(config.layout, 'tableLayouts.taskTable', {});
    const configTopHeaders = get(taskTableConfig, 'topHeaders', []);
    const configHeaders = get(taskTableConfig, 'mainHeaders', []);

    return {
      items: createTasks(taskList),
      headers: createTableHeaders(configHeaders),
      topHeaders: createTopTableHeaders(configTopHeaders),
      totalResultCount: get(state, 'totalResultCountTaskListAll', 0),
    };
  },
  isTaskDataLoading: state => {
    return state.isLoading;
  },
  getNewTasksCount: state => state.newTasksCount,
  getNewTasksAllCount: state => state.newTasksAllCount,
};
